import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import {
  formatDateWithTime,
  isReadOnlyUser,
  withRouter,
} from "../../shared/utility";
import { BarcodeHistoryViewModel } from "../../viewmodels/traceability/BarcodeHistoryViewModel";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { useRef, useState } from "react";
import BarcodeHistoryTable from "./barcodeHistory/BarcodeHistoryTable";
import EmptyModal from "../../components/modals/EmptyModal";
import { Skeleton } from "primereact/skeleton";
import ButtonSpinner from "../../components/controls/ButtonSpinner";

function BarcodeHistoryScreen(props) {
  const { logout } = props;
  const {
    product,
    getBarcodeHistory,
    loading,
    emptyModal,
    setEmptyModelOpen,
    reprintLabel,
    askDeleteManufacturedItemByBarcode,
  } = BarcodeHistoryViewModel(logout);

  const searchRef = useRef();
  const isReadOnly = isReadOnlyUser();

  const [reportType, setReportType] = useState(0);

  return (
    <div>
      <div className="mt-2 lg:px-8 space-y-4">
        <div className="sm:flex sm:items-center px-4 py-5 card-custom">
          <div className="sm:flex-auto">
            <h1 className="text-base font-semibold leading-6 text-gray-900">
              Carton History
            </h1>
            <div className="mt-5 flex rounded-md">
              <div className="relative flex items-stretch flex-grow focus-within:z-10">
                <input
                  type="search"
                  name="searchProduct"
                  id="searchProduct"
                  className="block w-full rounded-lg rounded-l-md pl-2 sm:text-sm border border-gray-300 rounded-tr-none rounded-br-none"
                  placeholder="Search by barcode"
                  ref={searchRef}
                  onKeyDown={(e) => {
                    if (e.key === "Enter")
                      getBarcodeHistory(searchRef.current.value, reportType);
                  }}
                />
              </div>
              <button
                type="button"
                className="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1"
                onClick={() =>
                  getBarcodeHistory(searchRef.current.value, reportType)
                }
              >
                <MagnifyingGlassIcon
                  className="h-5 w-5 text-gray-400"
                  aria-hidden="true"
                />
              </button>
            </div>
          </div>
        </div>
        {loading ? (
          <div className="space-y-2">
            <Skeleton width="100%" height="8rem" borderRadius="16px"></Skeleton>
            <Skeleton width="100%" height="8rem" borderRadius="16px"></Skeleton>
          </div>
        ) : product.serial ? (
          <div>
            <div className="float-right flex gap-2">
              <button
                className="rounded-md bg-main-purple px-1.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                onClick={reprintLabel}
              >
                <ButtonSpinner spin={false} text="Reprint" />
              </button>
              {!isReadOnly && product.itemType === "manufactured" ? (
                <button
                  className="rounded-md bg-red-600 px-1.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
                  onClick={askDeleteManufacturedItemByBarcode}
                >
                  <ButtonSpinner spin={false} text="Delete" />
                </button>
              ) : null}
            </div>
            <div>
              <div className="px-4 py-5 card-custom">
                <div className="grid grid-cols-2 gap-4">
                  <div className="space-y-2">
                    <p>Serial #: {product.serial}</p>
                    <p>PLU: {product.plu}</p>
                    <p>Name: {product.name}</p>
                    <p>Name (CH): {product.name_ch}</p>
                    <p>Lot #: {product.lot_number}</p>
                    <p>
                      Last scan date: {formatDateWithTime(product.lastScanDate)}
                    </p>
                    <p className="font-bold text-cyan-700">
                      Status: {product.statusReason}
                    </p>
                  </div>
                  <div className="space-y-2">
                    <p>On hand weight: {product.on_hand_net_kg} kg</p>
                    <p>On hand pieces: {product.on_hand_piece_count}</p>
                    <p>Barcode: {product.barcode}</p>
                    <p>Location: {product.warehouse_location_name}</p>
                    <p>Total cartons: {product.total_cartons}</p>
                    <p>Inv. by plu: {product.inv_on_hand_by_plu}</p>
                    <p>Inv. by lot: {product.inv_on_hand_by_lot}</p>
                  </div>
                </div>
              </div>
            </div>
            <BarcodeHistoryTable historyData={product.barcode_histories} />
          </div>
        ) : null}
      </div>

      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
        size={emptyModal.size}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BarcodeHistoryScreen)
);
